import { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { Typography } from '../Typography/Typography';

import s from './styles.module.scss';
import { IconButton } from '@mui/material';

interface EditHeaderProps {
  title: ReactNode | string;
  link?: string;
  goBack?: boolean;
}

/** @deprecated Use EditHeaderV2 instead */
export const EditHeader = ({ title, link, goBack }: EditHeaderProps) => {
  const navigate = useNavigate();

  return (
    <header className={s.header}>
      {link && (
        <Link
          to={link}
          aria-label="Вернуться назад"
          style={{
            display: 'flex',
            width: '32px',
            height: '32px',
            alignItems: 'center',
          }}
        >
          <ArrowBackIosIcon
            sx={{ width: '20px', height: '20px', fill: '#1976D2', marginLeft: '10px' }}
          />
        </Link>
      )}

      {goBack && (
        <IconButton
          onClick={() => navigate(-1)}
          aria-label="Вернуться назад"
          style={{
            display: 'flex',
            width: '32px',
            height: '32px',
            alignItems: 'center',
          }}
        >
          <ArrowBackIosIcon
            sx={{ width: '20px', height: '20px', fill: '#1976D2', marginLeft: '10px' }}
          />
        </IconButton>
      )}

      {typeof title === 'string' ? (
        <Typography fontSize="1.5rem" lineHeight="42px" letterSpacing="0.25px">
          {title}
        </Typography>
      ) : (
        title
      )}
    </header>
  );
};
